import { render, staticRenderFns } from "./HospitalExpenses.vue?vue&type=template&id=25f466a8&scoped=true"
import script from "./HospitalExpenses.vue?vue&type=script&lang=js"
export * from "./HospitalExpenses.vue?vue&type=script&lang=js"
import style0 from "./HospitalExpenses.vue?vue&type=style&index=0&id=25f466a8&prod&scoped=true&lang=css"
import style1 from "./HospitalExpenses.vue?vue&type=style&index=1&id=25f466a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f466a8",
  null
  
)

export default component.exports